import script from "./PartCollectionThumbnail.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartCollectionThumbnail.vue?vue&type=script&setup=true&lang=ts"

import "./PartCollectionThumbnail.vue?vue&type=style&index=0&id=0fe4bff3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe4bff3"]])

export default __exports__